import { render } from "./hotline.vue?vue&type=template&id=7c3e989c"
import script from "./hotline.vue?vue&type=script&lang=js"
export * from "./hotline.vue?vue&type=script&lang=js"

import "./hotline.vue?vue&type=style&index=0&id=7c3e989c&lang=less"

import exportComponent from "E:\\ekt.pro.git\\new-ekt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__